/**
 * @Author: v_jppjpeng
 * @Date: 2023-03-11 11:04:53
 * @Explain: 占位符管理
 */
export default {
  // 列表
  'PLACEHOLDER.MANAGE.LIST.TITLE': '占位符列表',
  'PLACEHOLDER.MANAGE.TIPS2.TITLE': '用固定值替换',
  'PLACEHOLDER.MANAGE.TIPS3.TITLE': '用动态值替换',
  'PLACEHOLDER.MANAGE.TIPS1':
    '你可以创建一个资源码，插入到模板中，随活动随机发送给联系人。',
  'PLACEHOLDER.MANAGE.TIPS2':
    '资源码用光会导致活动异常，资源码应用到活动中后，请保证资源码余量充足。',
  'PLACEHOLDER.MANAGE.TIPS3':
    '资源码将在交付前被替换成实时查询的值。例如，个人信息，如生日、区域、语言等，以及游戏内信息，如角色昵称、胜率等。',
  'PLACEHOLDER.MANAGE.REPLACE.WITH.FIXED.VALUE': '用固定值替换',
  'PLACEHOLDER.MANAGE.REPLACE.WITH.DYNAMIC.VALUE': '用动态值替换',
  'PLACEHOLDER.MANAGE.TEMPLATE.VAR': '模板变量',
  'PLACEHOLDER.MANAGE.PLEASE.SELECT.TEMPLATE': '请选择模板',
  'PLACEHOLDER.MANAGE.SEARCH.PLACEHOLDER': '搜索资源码的名称',
  'PLACEHOLDER.MANAGE.NAME': '资源码名称',
  'PLACEHOLDER.MANAGE.AMOUNT.OF.VALUES': '值的数量',
  'PLACEHOLDER.MANAGE.USED': '已使用',
  'PLACEHOLDER.MANAGE.REAMAINING': '剩余',
  'PLACEHOLDER.MANAGE.USAGE': '使用情况',
  'PLACEHOLDER.MANAGE.VALUE.TO.REPLACE.WITH': '替换值来源',
  'PLACEHOLDER.MANAGE.DEFAULT.VALUE': '默认值',
  'PLACEHOLDER.MANAGE.EXPORT.DETAILS': '导出详情',
  'PLACEHOLDER.MANAGE.PLATFORM': '发放平台',
  'PLACEHOLDER.MANAGE.DISTRIBUTE.PROGRESS': '发放进度',
  'PLACEHOLDER.MANAGE.IMPORT': '导入',

  // 删除
  'PLACEHOLDER.MANAGE.DEL.TITLE': '确定删除资源码？',
  'PLACEHOLDER.MANAGE.DEL.DESC':
    '删除 <b class="color-333">{name}</b> 后，资源码信息不可恢复。',

  // 详情
  'PLACEHOLDER.MANAGE.BASIC.INFO': '基础信息',
  'PLACEHOLDER.MANAGE.TYPE': '类型',
  'PLACEHOLDER.MANAGE.AMOUNT': '数量',
  'PLACEHOLDER.MANAGE.DELIVERY.STATUS': '投递状态',
  'PLACEHOLDER.MANAGE.CAMPAIGNS': '活动',
  'PLACEHOLDER.MANAGE.CAMPAIGN': '活动/旅程',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.Campaign': '活动',
  'PLACEHOLDER.MANAGE.CLASSIFICATION.JOUNEY': '旅程',
  'PLACEHOLDER.MANAGE.AVAILIBLE.IN.POLL': '可用 / 待发放',
  'PLACEHOLDER.MANAGE.CLASSIFICATION.EMAIL.CAMPAIGN': '邮件活动',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.Double.OptIn.Email': '二次确认邮件',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.Form': '表单',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.SelectedTemplates': '邮件模板',
  'PLACEHOLDER.MANAGE.PROGRESS.OF.DELIEVERY': '投递进度',
  'PLACEHOLDER.MANAGE.SEARCH.FOR.THE.VALUE': '搜索值',
  'PLACEHOLDER.MANAGE.SEARCH.VALUE.EMAIL': '搜索变量值或邮箱',
  'PLACEHOLDER.MANAGE.PLACEHOLDER': '资源码',
  'PLACEHOLDER.MANAGE.VALUE': '资源码',
  'PLACEHOLDER.MANAGE.PROGRESS.LABEL':
    '<span style="color: rgba(255, 255, 255, 0.7);">已发放</span> {molecule} / <span style="color: rgba(255, 255, 255, 0.7);">合计</span> {denominator}',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.BY.ACTIVITY': '活动分发占比',
  'PLACEHOLDER.MANAGE.ACTIVITIES': '事件',
  'PLACEHOLDER.MANAGE.ACTIVITIES.SEARCH.PLACEHOLDER': '搜索事件名称',
  'PLACEHOLDER.MANAGE.ACTIVITY.NAME': '名称',
  'PLACEHOLDER.MANAGE.RATE': '比率',
  'PLACEHOLDER.MANAGE.IMPORT.DATE': '导入日期',
  'PLACEHOLDER.MANAGE.USER.EMAIL': '发放给',
  'PLACEHOLDER.MANAGE.DELIVER.TIME': '发放日期',
  'PLACEHOLDER.MANAGE.AVAILABLE': '可用',
  'PLACEHOLDER.MANAGE.DISTRIBUTED': '已发放',

  'PLACEHOLDER.MANAGE.LI.PASS.EMAIL': 'LEVEL INFINITE PASS 欢迎邮件',
  'PLACEHOLDER.MANAGE.CONTACTS.WELCOME.EMAIL': 'API导入联系人-欢迎邮件',
  'PLACEHOLDER.MANAGE.Export': '导出',
  'PLACEHOLDER.MANAGE.Export.SUCCESS':
    '导出任务提交成功，请到<span class="color-primary">导出中心</span>下载文件',
  'PLACEHOLDER.MANAGE.Export.FAILED': '导出失败请重试',
  'PLACEHOLDER.MANAGE.Export.DIALOG.HEADER': '确认导出资源码详情？',
  'PLACEHOLDER.MANAGE.Export.DIALOG.CHILDREN.SURE':
    '确认导出后，系统将在导出中心创建导出任务。导出过程需要一段时间，完成后您将收到邮件通知。',
  'PLACEHOLDER.MANAGE.Export.DIALOG.CHILDREN.NOTE':
    '注意：联系人来源仅为 LEVEL INFINITE PASS 时，只能导出加密邮箱。',

  // 模板变量 - 新增、编辑
  'PLACEHOLDER.MANAGE.CREATE.PLACEHOLDER': '创建资源码',
  'PLACEHOLDER.MANAGE.EDIT.PLACEHOLDER': '编辑资源码',
  'PLACEHOLDER.MANAGE.IMPORT.PLACEHOLDER': '导入资源码',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.NAME': '资源码名称',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.CreateKeysTips':
    '此处创建的资源码支持插入模板中，码值需要提前导入。适用于随机向用户发送礼品代码、促销代码、赎回代码。',
  'PLACEHOLDER.MANAGE.PLEASE.ENTER.PLACEHOLDER.NAME': '请输入资源码名称',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.PLATFORM': '发放平台',
  'PLACEHOLDER.MANAGE.STEAM': 'Steam',
  'PLACEHOLDER.MANAGE.KEY.POOL.NAME': '资源码名称',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.PLATFORM.PLACHOLDER': '选择平台',
  'PLACEHOLDER.MANAGE.DISTRIBUTION': '描述',
  'PLACEHOLDER.MANAGE.DISTRIBUTION.PLACHOLDER':
    '例如：Q4营销活动的 Steam 测试版激活码（2025-01 批次）',
  'PLACEHOLDER.MANAGE.KEY.CONTENT.TYPE': '资源码兑换内容',
  'PLACEHOLDER.MANAGE.BASE.GAME': '正式版游戏',
  'PLACEHOLDER.MANAGE.DLC': 'DLC',
  'PLACEHOLDER.MANAGE.PLAYTEST': '测试版游戏',
  'PLACEHOLDER.MANAGE.TARGET.STEAM.APP.ID': 'Steam应用ID',
  'PLACEHOLDER.MANAGE.TARGET.BASE.GAME.ID': '游戏本体应用ID',
  'PLACEHOLDER.MANAGE.TARGET.DLC.APP.ID': 'DLC应用ID',
  'PLACEHOLDER.MANAGE.ITEM.ID': '物品ID',
  'PLACEHOLDER.MANAGE.IDS.MESSAGE': '只能输入 数字、字母',
  'PLACEHOLDER.MANAGE.IDS.NUMBER.MESSAGE': 'ID仅支持输入数字',
  'PLACEHOLDER.MANAGE.IDS.NUMBER.MAX.LEN.MESSAGE': '输入内容过长，请缩短后重试',
  'PLACEHOLDER.MANAGE.SAVE.AND.IMPORT': '保存&导入资源码',
  'PLACEHOLDER.MANAGE.FILE.SUMMART': '导入预览',
  'PLACEHOLDER.MANAGE.FILE.PASS.TIPS': '{num}个资源码可用，将被导入',
  'PLACEHOLDER.MANAGE.FILE.FORMAT.ERROR':
    '{num}个资源码格式不匹配通用样式，但也将被导入',
  'PLACEHOLDER.MANAGE.FILE.REPEAT.ERROR': '{num}个资源码由于重复将跳过不被导入',
  'PLACEHOLDER.MANAGE.PLACEHOLDER.TYPE': '资源码类型',
  'PLACEHOLDER.MANAGE.FIXED.VALUE': '固定值',
  'PLACEHOLDER.MANAGE.DYNAMIC.VALUE': '动态值',
  'PLACEHOLDER.MANAGE.FIXED.VALUE.TIPS':
    '资源码将用离线的固定值替换，例如礼品代码、促销代码、赎回代码。您需要提前导入这些值。',
  'PLACEHOLDER.MANAGE.UPLOAD.VALUES': '上传值',
  'PLACEHOLDER.MANAGE.PLEASE.UPLOAD.DYNAMIC.VAR.FILE': '请上传变量值文件',
  'PLACEHOLDER.MANAGE.SELECT.REPLACE.VALUE': '选择值去替换',
  'PLACEHOLDER.MANAGE.PERSONAL.INFO': '个人信息',
  'PLACEHOLDER.MANAGE.SET.DEFAULT.VALUE': '设置为默认值',
  'PLACEHOLDER.MANAGE.PLEASE.ENTER.DEFAULT.VALUE': '请输入默认值',
  'PLACEHOLDER.MANAGE.DEFAULT.VALUE.TIPS':
    '在动态值查询失败的情况下，默认值将被替换。',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS1': '在此拖放一个新文件(.xlxs)，或 ',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS1-1': '点击',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS1-2': ' 上传',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS2-1':
    '从 XLSX 文件中导入资源。导入限制为 {size}。',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS2-2':
    '对于较大的列表，请将文件拆分为较小的文件并逐个上传。',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS2-3': '导入文件需要使用UTF-8编码',
  'PLACEHOLDER.MANAGE.UPLOAD.TIPS3':
    '共有{total}个数值。如果所有值都投递完毕，该活动将暂停投递。',
  'PLACEHOLDER.MANAGE.TIP': '*系统会自动帮您去除重复变量',

  // 标题
  'PLACEHOLDER.MANAGE.TITLE': '选择资源码/联系人字段',
  'PLACEHOLDER.MANAGE.TITLE.WHATSAPP': '选择联系人字段',
  // 资源码
  'PLACEHOLDER.MANAGE.RESOURCE.CODE': '资源码',
  // 动态码
  'PLACEHOLDER.MANAGE.DYNAMIC.CODE': '动态码',
  // 联系人字段
  'PLACEHOLDER.MANAGE.CONTACT.FIELD': '联系人字段',

  'PLACEHOLDER.MANAGE.PLACEHOLDER.NAME.TIP': '此处仅支持插入一个变量',
  // 创建资源码
  'PLACEHOLDER.MANAGE.CREATE.KEYS.DOWNLOAD': '下载模板',
};
